import React, { ReactNode } from "react";
import Alert from "../../../components/Alerts/Alert";
import { useProjectConfigContext } from "../../../contexts/ProjectConfigContext";
import { AlertColors } from "../../../enums/colors/alertColors.type";
import { useTags } from "../../../hooks/useTags";
import { topDeclarationLang } from "../../../data/lang/add-request-page.lang";


export default function TopDeclaration() {

    const { projectConfigState } = useProjectConfigContext();

    const generateTag = useTags();
    const title = generateTag(topDeclarationLang, 'title');
    const proId12Line1 = generateTag(topDeclarationLang, 'project-id-12.line-1');
    const proId12Line2 = generateTag(topDeclarationLang, 'project-id-12.line-2');
    const proId12Line3 = generateTag(topDeclarationLang, 'project-id-12.line-3');
    const proId26Line1 = generateTag(topDeclarationLang, 'project-id-26.line-1');
    const proId26Line2 = generateTag(topDeclarationLang, 'project-id-26.line-2');
    const proId26Line3 = generateTag(topDeclarationLang, 'project-id-26.line-3');
    const proId26Line4 = generateTag(topDeclarationLang, 'project-id-26.line-4');
    const proId26Line5 = generateTag(topDeclarationLang, 'project-id-26.line-5');
    const proId51Line1 = generateTag(topDeclarationLang, 'project-id-51.line-1');
    const proId51Line2 = generateTag(topDeclarationLang, 'project-id-51.line-2');

    const proId32Title = generateTag(topDeclarationLang, 'project-id-32.title');
    const proId32Line1 = generateTag(topDeclarationLang, 'project-id-32.l1');
    const proId32Line2 = generateTag(topDeclarationLang, 'project-id-32.l2');
    const proId32Line3 = generateTag(topDeclarationLang, 'project-id-32.l3');
    const proId32Line4 = generateTag(topDeclarationLang, 'project-id-32.l4');

    const fillForm = generateTag(topDeclarationLang, 'fill-form');

    const projectId = projectConfigState.projectId;
    let message: string | ReactNode = '';

    if (projectId === 26) {

        message = (
            <p>
                <span>{proId26Line1}</span>
                <br />
                <span>{proId26Line2}</span>
                <br />
                <span>{proId26Line3}</span>
                <br />
                <span>{proId26Line4}</span>
                <br />
                <span>{proId26Line5}</span>
            </p>
        );

    } else if (projectId === 51) {

        message = (
            <div>
                <span>{proId51Line1}</span>
                <br />
                <span>{proId51Line2}</span>
            </div>
        );
    } else if (projectId === 12) {

        message = (
            <div className="mt-1">
                <div className="">{proId12Line2}</div>
                <div className="">{proId12Line3}</div>
                <div className="fw-bold text-danger">{proId12Line1}</div>
            </div>
        );
    } else if (projectId === 32) {
        message = (
            <div className="mt-1">
                <div className="fw-bold">{proId32Title}</div>
                <ul>
                    <li>{proId32Line1}</li>
                    <li>{proId32Line2}</li>
                    <li>{proId32Line3}</li>
                    <li>{proId32Line4}</li>
                </ul>
            </div>
        )
    }


    return (
        <Alert type={AlertColors.SECONDARY}
            message={(
                <div className="p-2">
                    {fillForm}
                    {message}
                </div>
            )}
            isShow={true}
            subject={title}
        />
    );
}
